import { Controller } from "@hotwired/stimulus";
import { Offcanvas } from "bootstrap";

export default class extends Controller<HTMLElement> {
  private _offcanvas?: Offcanvas;

  connect(): void {
    this._offcanvas = new Offcanvas(this.element);
  }

  show(event: Event) {
    event.preventDefault();

    this._offcanvas?.show();
  }

  hide(event: Event) {
    event.preventDefault();

    this._offcanvas?.hide();
  }
}
